/**
 * Componente NotFoundSection
 * Sección 404 para páginas no encontradas
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { Trans } from "react-i18next";
import MotionWrapper from "../../shared/components/MotionWrapper";
import ComicButton from "../../shared/components/ComicButton/ComicButton";

const NotFoundSection = () => {
    const navigate = useNavigate();

    return (
        <MotionWrapper sectionKey="404">
            <h1 className="text-4xl font-bold text-white mb-4">
                <Trans i18nKey="notFoundTitle">404 - Página no encontrada</Trans>
            </h1>
            <p className="text-white mb-8">
                <Trans i18nKey="notFoundMessage">
                    Lo sentimos, la página que buscas no existe.
                </Trans>
            </p>
            <ComicButton
                buttonName={<Trans i18nKey="backToHome">Volver al inicio</Trans>}
                hoverBtnName={<Trans i18nKey="backToHome">Volver al inicio</Trans>}
                handleButtonClick={() => navigate("/")}
            />
        </MotionWrapper>
    );
};

export default NotFoundSection;
